import i18n from '@/i18n'
import Store from '@/store'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'
import Custom from '../../../../../store/custom'
import ReportHeading from '@/Utils/report-head'

function getOrgName (orgId) {
  let orgName = ''
  const Obj = Store.state.commonObj.organizationProfileList.find(item => item.value === orgId && item.status === 0)
  if (i18n.locale === 'bn') {
    orgName = Obj.text_bn
  } else {
    orgName = Obj.text_en
  }
  return orgName
}
function getInstituteType (Id) {
  let instituteName = ''
  const Obj = Store.state.commonObj.officeTypeList.find(item => item.value === Id && item.status === 0)
  if (i18n.locale === 'bn') {
    instituteName = Obj.text_bn
  } else {
    instituteName = Obj.text_en
  }
  return instituteName
}
function getAreaType (Id) {
  const tmpData = Custom.wardTypeList.find(item => item.id === Id)
  if (i18n.locale === 'bn') {
    return tmpData.name_bn
  } else {
    return tmpData.name
  }
}
function getWardName (Id) {
  const tmpData = Store.state.commonObj.wardList.find(item => item.value === Id && item.status === 0)
  if (i18n.locale === 'bn') {
      return tmpData.text_bn
  } else {
      return tmpData.text_en
  }
}
function getUnionName (Id) {
  const tmpData = Store.state.commonObj.unionList.find(item => item.value === Id && item.status === 0)
  if (i18n.locale === 'bn') {
      return tmpData.text_bn
  } else {
      return tmpData.text_en
  }
}
function getUpazilaName (Id) {
  const tmpData = Store.state.commonObj.upazilaList.find(item => item.value === Id && item.status === 0)
  if (i18n.locale === 'bn') {
      return tmpData.text_bn
  } else {
      return tmpData.text_en
  }
}
function getDivisionName (Id) {
  const tmpData = Store.state.commonObj.divisionList.find(item => item.value === Id && item.status === 0)
  if (i18n.locale === 'bn') {
      return tmpData.text_bn
  } else {
      return tmpData.text_en
  }
}
function getPourosobaName (Id) {
  const tmpData = Store.state.commonObj.pauroshobaList.find(item => item.value === Id && item.status === 0)
  if (i18n.locale === 'bn') {
      return tmpData.text_bn
  } else {
      return tmpData.text_en
  }
}
function getCityCorpName (Id) {
  const tmpData = Store.state.commonObj.cityCorporationList.find(item => item.value === Id && item.status === 0)
  if (i18n.locale === 'bn') {
      return tmpData.text_bn
  } else {
      return tmpData.text_en
  }
}
function getDistrictName (Id) {
  const tmpData = Store.state.commonObj.districtList.find(item => item.value === Id && item.status === 0)
  if (i18n.locale === 'bn') {
      return tmpData.text_bn
  } else {
      return tmpData.text_en
  }
}

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, seizeData, vm) => {
    try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)
      const pdfContent = []
      pdfContent.push(
        {
          table: {
            style: 'tableData',
            headerRows: 0,
            widths: ['25%', '50%', '25%'],
            body: [
              [
                { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
                { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                { image: reportHeadData.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
              ],
              [
                {},
                { text: reportHeadData.orgName, style: 'header2', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportHeadData.heading, style: 'address', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportHeadData.address, style: 'address2', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: 'www.spst.gov.bd', style: 'td2', alignment: 'center' },
                {}
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        }
      )
      pdfContent.push(
          { text: reportTitle, style: 'header', alignment: 'center', decoration: 'underline' }
      )
        const topRows = [
          [
            { text: vm.$t('globalTrans.organization'), bold: true, style: 'td' },
            { text: getOrgName(seizeData.org_id), style: 'td' },
            { text: vm.$t('child_configuration.institute_type'), bold: true, style: 'td' },
            { text: getInstituteType(seizeData.office_type_id), style: 'td' }
          ],
          [
            { text: vm.$t('child_configuration.institute_name'), bold: true, style: 'td' },
            { text: vm.$i18n.locale === 'bn' ? seizeData.institute_name : seizeData.institute_name_bn, style: 'td' },
            { text: vm.$t('globalTrans.date'), bold: true, style: 'td' },
            { text: seizeData.date, style: 'td' }
          ],
          [
            { text: vm.$t('rehabilitation_management.applicant_name'), bold: true, style: 'td' },
            { text: vm.$i18n.locale === 'bn' ? seizeData.name_bn : seizeData.name, style: 'td' },
            { text: vm.$t('rehabilitation_management.registration_id'), bold: true, style: 'td' },
            { text: seizeData.registration_id, style: 'td' }
          ],
          [
            { text: vm.$t('child_configuration.rehabilitation_type'), bold: true, style: 'td' },
            { text: vm.getRehabilitationTypeList(seizeData.rehabilitation_type_id), style: 'td' },
            { text: vm.$t('rehabilitation_management.contact_no'), bold: true, style: 'td' },
            { text: seizeData.contact_no, style: 'td' }
          ],
          [
            { text: vm.$t('rehabilitation_management.rehabilitation_to'), bold: true, style: 'td' },
            { text: vm.$i18n.locale === 'bn' ? seizeData.rehabilitation_to_bn : seizeData.rehabilitation_to, style: 'td' },
            { text: vm.$t('production_service_config.area_type_id'), bold: true, style: 'td' },
            { text: getAreaType(seizeData.area_type_id), style: 'td' }
          ],
          [
            { text: vm.$t('production_service_config.division_id'), bold: true, style: 'td' },
            { text: getDivisionName(seizeData.division_id), style: 'td' },
            { text: vm.$t('production_service_config.district_id'), bold: true, style: 'td' },
            { text: getDistrictName(seizeData.district_id), style: 'td' }
          ],
          [
            { text: vm.$t('production_service_config.upazila_id'), bold: true, style: 'td' },
            { text: seizeData.upazila_id ? getUpazilaName(seizeData.upazila_id) : 'N/A', style: 'td' },
            { text: vm.$t('production_service_config.city_corporation_id'), bold: true, style: 'td' },
            { text: seizeData.city_corporation_id ? getCityCorpName(seizeData.city_corporation_id) : 'N/A', style: 'td' }
          ],
          [
            { text: vm.$t('production_service_config.union_id'), bold: true, style: 'td' },
            { text: seizeData.union_id ? getUnionName(seizeData.union_id) : 'N/A', style: 'td' },
            { text: vm.$t('production_service_config.paurasabha_id'), bold: true, style: 'td' },
            { text: seizeData.paurasabha_id ? getPourosobaName(seizeData.paurasabha_id) : 'N/A', style: 'td' }
          ],
          [
            { text: vm.$t('production_service_config.ward_id'), bold: true, style: 'td' },
            { text: seizeData.ward_id ? getWardName(seizeData.ward_id) : 'N/A', style: 'td' },
            { text: vm.$t('production_service_config.address'), bold: true, style: 'td' },
            { text: vm.$i18n.locale === 'bn' ? seizeData.address_bn : seizeData.address, style: 'td' }
          ],
          [
            { text: vm.$t('legal_institute_management.remarks'), bold: true, style: 'td' },
            { text: vm.$i18n.locale === 'bn' ? seizeData.remarks_bn : seizeData.remarks, style: 'td', colSpan: '3' },
            {},
            {}
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 1,
            widths: ['20%', '30%', '20%', '30%'],
            body: topRows
          }
        })
        const waterMarkText = i18n.locale === 'bn' ? 'সমাজ কল্যাণ মন্ত্রণালয়' : 'Ministry of Social welfare'
        var docDefinition = {
        content: pdfContent,
        pageSize: 'A4',
        pageOrientation: 'portrait',
        watermark: { text: waterMarkText, color: 'blue', opacity: 0.1, bold: true, italics: false },
        styles: {
              th: {
                fillColor: '#dee2e6',
                fontSize: 10,
                margin: [3, 2, 3, 2]
              },
              td: {
                fontSize: 10,
                margin: [3, 2, 3, 2]
              },
              identity: {
                margin: [0, 5, 0, 3],
                fontSize: 12,
                alignment: 'center'
              },
              left_header: {
                margin: [4, 0, 0, 10]
              },
              header: {
                margin: [0, 10, 0, 10],
                fontSize: 14,
                alignment: 'center'
              },
              header2: {
                border: 0,
                fontSize: 14,
                margin: [0, 0, 0, 1]
              },
              govt_info: {
                margin: [0, 1, 0, 1],
                fontSize: 15,
                alignment: 'center'
              },
              address: {
                  border: 0,
                  fontSize: 10,
                  bold: true,
                  margin: [0, 0, 0, 1]
              },
              address2: {
                border: 0,
                fontSize: 12,
                bold: true,
                margin: [0, 0, 0, 1]
              },
              left_logo: {
                border: 0,
                margin: [5, 0, 0, 5]
              }
          }
        }
        pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {}
    }
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
